export default "__VITE_ASSET__Z24ZdNKb__"